export const BASE = 'PLAN_INTEGRATIONS_GET';
export const GET_START = `${BASE}_START`;
export const GET_SUCCESS = `${BASE}_SUCCESS`;
export const GET_FAIL = `${BASE}_FAIL`;

export function get(opts) {
  const { planId, params } = opts;

  return {
    type: BASE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}/integrations`,
      method: 'get',
      params,
    },
  };
}
